import useMediaQueries from '@stone/hooks/useMediaQueries';
import React, { useMemo } from 'react';
import '@stone/scss/components/editorial/_editorial.scss';
import EditorialGridImages from './EditorialImagesGrid';
import classNames from 'classnames';
import { kebabCase } from 'lodash';
import EditorialVideoContainer from './EditorialVideoContainer';
const Editorial = (props) => {
    const { isDesktop } = useMediaQueries();
    // ANCHOR - USE MEMO --------------------------------------------------------------------
    const components = useMemo(() => (props === null || props === void 0 ? void 0 : props.components) && JSON.parse(props.components)[0], [props]);
    const items = useMemo(() => (props === null || props === void 0 ? void 0 : props.listItems) && JSON.parse(props.listItems), [props]);
    const images = useMemo(() => { var _a, _b; return (_b = (_a = components === null || components === void 0 ? void 0 : components.regions) === null || _a === void 0 ? void 0 : _a.images) === null || _b === void 0 ? void 0 : _b.components; }, [components]);
    const checks = useMemo(() => {
        const IS_IMAGES = (components === null || components === void 0 ? void 0 : components.typeid) === 'component_editorial_image_grid';
        const IS_VIDEO = (components === null || components === void 0 ? void 0 : components.typeid) === 'component_editorial_video';
        const IS_HORIZONTAL = (components === null || components === void 0 ? void 0 : components.distribution) === 'HORIZONTAL';
        const IS_VERTICAL = (components === null || components === void 0 ? void 0 : components.distribution) === 'VERTICAL';
        const IS_TOP = props.position === 'TOP';
        const IS_BOTTOM = props.position === 'BOTTOM';
        const IS_OFFSET = props.alignement === 'OFFSET';
        const IS_RIGHT = props.alignement === 'RIGHT';
        const IS_GRID = (images === null || images === void 0 ? void 0 : images.length) > 3;
        const IS_CAROUSEL = !isDesktop && IS_IMAGES && ((images === null || images === void 0 ? void 0 : images.length) >= 3 || ((images === null || images === void 0 ? void 0 : images.length) >= 2 && IS_HORIZONTAL));
        const IS_IMAGES_POSITIONED = IS_IMAGES && ((images === null || images === void 0 ? void 0 : images.length) === 1 || ((images === null || images === void 0 ? void 0 : images.length) <= 2 && (IS_VERTICAL || (isDesktop && IS_OFFSET))));
        const IS_CONTENT_POSITIONED = IS_VIDEO || IS_IMAGES_POSITIONED;
        const IS_RIGHT_CONTENT_POSITION = isDesktop && IS_CONTENT_POSITIONED && IS_RIGHT;
        return {
            IS_IMAGES,
            IS_VIDEO,
            IS_HORIZONTAL,
            IS_VERTICAL,
            IS_TOP,
            IS_BOTTOM,
            IS_CAROUSEL,
            IS_OFFSET,
            IS_RIGHT,
            IS_RIGHT_CONTENT_POSITION,
            IS_IMAGES_POSITIONED,
            IS_CONTENT_POSITIONED,
            IS_GRID,
        };
    }, [components, isDesktop, images]);
    const { IS_IMAGES, IS_VIDEO, IS_TOP, IS_VERTICAL, IS_RIGHT, IS_HORIZONTAL, IS_BOTTOM, IS_OFFSET, IS_RIGHT_CONTENT_POSITION, IS_IMAGES_POSITIONED, IS_CONTENT_POSITIONED } = checks;
    const classes = useMemo(() => {
        // RIGHT VARIANT --------------------------------------------------------------------
        const RIGHT = {
            textsWrapper: IS_IMAGES
                ? (images === null || images === void 0 ? void 0 : images.length) === 1 || ((images === null || images === void 0 ? void 0 : images.length) === 2 && IS_VERTICAL)
                    ? 'inner-col-lg-8'
                    : 'inner-col-lg-10 inner-col-xxl-8'
                : IS_VIDEO
                    ? 'inner-col-lg-5 inner-col-xxl-4'
                    : 'inner-col-lg-10 inner-col-xxl-8',
            title: 'inner-col',
            description: 'inner-col',
            components: IS_VIDEO
                ? 'inner-col-md-fill inner-offset-lg-2 inner-offset-xxl-3 video-content'
                : IS_IMAGES_POSITIONED
                    ? (images === null || images === void 0 ? void 0 : images.length) === 2
                        ? 'inner-col-md-fill inner-offset-lg-3 inner-offset-xxl-2'
                        : 'inner-col-md-fill inner-offset-lg-3'
                    : 'inner-col',
        };
        // OFFSET VARIANT --------------------------------------------------------------------
        const pos_col = (images === null || images === void 0 ? void 0 : images.length) === 1 ? 9 : (images === null || images === void 0 ? void 0 : images.length) == 2 ? (IS_VERTICAL ? 10 : 13) : 20;
        const OFFSET = {
            textsWrapper: 'inner-col',
            title: 'inner-col-lg-6',
            description: 'inner-col-lg-13 inner-offset-lg-1 column-split ',
            components: IS_CONTENT_POSITIONED ? (IS_VIDEO ? 'inner-col-md-fill inner-offset-lg-7 video-content' : `inner-col-lg-${pos_col} inner-offset-lg-7`) : 'inner-col',
        };
        return IS_OFFSET ? OFFSET : RIGHT;
    }, [checks]);
    // ANCHOR - RENDERS --------------------------------------------------------------------
    const renderItems = () => (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "inner-col-lg-13 inner-offset-lg-7" },
            React.createElement("ul", { className: "editorial-listitems" }, items.map((item, i) => (React.createElement("li", { className: "editorial-listitems-item", key: `${i}-${kebabCase(item.title)}` },
                React.createElement("h3", { className: "font__title" }, item.title),
                React.createElement("div", { className: "editorial-listitems-item--copy", dangerouslySetInnerHTML: { __html: item.copy } }))))))));
    const renderTexts = () => (React.createElement("div", { className: `${classes.textsWrapper} editorial-texts` },
        React.createElement("div", { className: "row editorial-texts-row" },
            React.createElement("div", { className: classes.title },
                React.createElement("h2", { className: "font__title editorial-title" }, props.title)),
            React.createElement("div", { className: `${classes.description} editorial-description`, dangerouslySetInnerHTML: { __html: props.copy } }))));
    const renderContent = () => (React.createElement("div", { className: classNames(classes.components, { top: IS_TOP }, { bottom: IS_BOTTOM }) },
        IS_IMAGES && React.createElement(EditorialGridImages, { images: images, checks: checks }),
        IS_VIDEO && React.createElement(EditorialVideoContainer, Object.assign({}, components))));
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: classNames('col-lg-20 offset-lg-2', { 'editorial-rows': IS_VIDEO || IS_IMAGES }, { single: (images === null || images === void 0 ? void 0 : images.length) === 1 }, { right: IS_RIGHT }, { 'is-video': IS_VIDEO }) },
                !IS_RIGHT_CONTENT_POSITION && IS_TOP && React.createElement("div", { className: "row" }, renderContent()),
                React.createElement("div", { className: "row " },
                    React.createElement(React.Fragment, null,
                        renderTexts(),
                        IS_RIGHT_CONTENT_POSITION && renderContent())),
                (items === null || items === void 0 ? void 0 : items.length) && renderItems(),
                !IS_RIGHT_CONTENT_POSITION && IS_BOTTOM && React.createElement("div", { className: "row" }, renderContent())))));
};
export default Editorial;
